<app-header></app-header>
<section class="inerpages-banner">
    <img src="{{imgurl}}{{page.pImage}}" class="w-100">
    <!-- <img src="assets/img/bg-innerpage.jpg" class="w-100" alt=""> -->
    <div class="fade-bg"></div>
    <div class="mask-content-v-center text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="tbox-iner text-center animate zoomIn" data-anim-type="zoomIn">
                        <div class="heading-iner">
                            <h2>{{page.pTitle}}</h2>
                            <hr>
                            <p> {{page.pSmallDesc}} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="pri-policy-page py-5">
  <div class="container">
     <div class="row">
    <div class="col-md-12 ">
     <h3 class="text-center heading">{{page.pTitle}}</h3>
     <div [innerHtml]="page.pDescription">

     </div>
    </div>
      </div>
    </div>
</section>             
